import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
function Card({ className, noBorder, children, padding, noMaxWidth = true, }) {
    return (_jsx("div", { className: clsx('content-card w-full max-w-3xl rounded-lg bg-brand-background-content', { 'border border-brand-border': !noBorder }, { 'm-4 p-4 sm:m-0 sm:p-6 lg:p-8': padding }, { 'max-w-sm': !noMaxWidth }, className), children: children }));
}
export { Card };
//# sourceMappingURL=Card.js.map